import { SVGProps } from 'react'

export const TimeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 2.58325V8.83325H6.76042L6.75 8.84367L10.9167 12.9999L6.75 17.1666L6.76042 17.177H6.75V23.4166H19.25V17.177H19.2396L19.25 17.1666L15.0833 12.9999L19.25 8.84367L19.2396 8.83325H19.25V2.58325H6.75ZM17.1667 17.6874V21.3333H8.83333V17.6874L13 13.5208L17.1667 17.6874ZM13 12.4791L8.83333 8.31242V4.66659H17.1667V8.31242L13 12.4791Z"
      fill="currentColor"
    />
  </svg>
)
